import { styled } from '@mui/material'
import { t } from '$i18n'

const Container = styled('div')({
  height: 20,
  padding: '0 6px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 10,

  border: '2px solid #fff',
  backgroundColor: '#FF1C7A',

  '& > span': {
    color: '#fff',
    fontSize: 10,
    fontWeight: 500,
    lineHeight: '14px',
  },
})

export function LiveBadge() {
  return (
    <Container>
      <span>{t('common.live')}</span>
    </Container>
  )
}

LiveBadge.defaultProps = {
  hasStroke: false,
}
